<section class="section">
	<ul class="breadcrumb breadcrumb-style ">
		<li class="breadcrumb-item">
			<h4 class="page-title m-b-0">Support Ticket</h4>
		</li>
		<li class="breadcrumb-item">
			<a routerLink="/dashboard">
				<i data-feather="home"></i></a>
		</li>
		<li class="breadcrumb-item active">Support Ticket List</li>
	</ul>

	<div class="card">
		<div class="card-header">
			<!-- <div class="col-xl col-md-4 col-sm-12">
				<div class="card-statistic">
					<div class="banner-img">
						<img src="assets/img/custom-images/dashboard/support-ticket.svg" alt="Support Ticket">
					</div>
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">Open</h6>
						<h4 class="text-left"><span>0</span>
						</h4>
					</div>
				</div>
			</div> -->

			<!-- <a href="#/unassinged-tickets" routerlink="/unassinged-tickets" class="badge badge-warning mr-2"><span  class="icon"><img src="assets/img/custom-images/dashboard/support-ticket.svg" alt="Support Ticket"></span> &nbsp; Queue Tickets </a> -->
			<div class="ticket-section">

				<div class="col-3 col-md-3 col-xl-2 tile open-color active-filter" id="open-counts"
					(click)="selectDisplay($event,'open-counts')">
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">Open Tickets</h6>
						<h4 class="text-left"><span>{{counts.open}}</span>
						</h4>
					</div>
				</div>

				<div class="col-3 col-md-3 col-xl-2 tile queue-color inactive-menu" id="queue-counts"
					(click)="selectDisplay($event,'queue-counts')">
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">Unread Tickets</h6>
						<h4 class="text-left"><span>{{counts.unread}}</span>
						</h4>
					</div>
				</div>
				<div class="col-3 col-md-3 col-xl-2 tile closed-color inactive-menu" id="close-counts"
					(click)="selectDisplay($event,'close-counts')">
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">Closed Tickets</h6>
						<h4 class="text-left"><span>{{counts.closed}}</span>
						</h4>
					</div>
				</div>
			</div>
			<!-- <button type="submit"  style="width: 150px;" class="btn btn-success" (click)="createticket()"><i class="fas fa-plus-circle"></i> Create Tickets</button>   -->
			<a routerLink="/support-ticket-list" class="gradient-btn">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="app-icon">
					<path
						d="M6.313 12.929l9.442-9.246c.478-.468.488-1.236.022-1.716s-1.231-.49-1.709-.022L2.499 13.273c-.226.22-.366.529-.366.87s.14.649.366.87l11.569 11.328c.478.468 1.243.458 1.709-.022s.456-1.248-.022-1.716l-9.442-9.246h15.769c2.67 0 4.834 2.174 4.834 4.855v9.508c0 .67.541 1.214 1.209 1.214s1.209-.543 1.209-1.214v-9.508c0-4.022-3.247-7.283-7.252-7.283H6.313z">
					</path>
				</svg>
				Back</a>
		</div>

	</div>


	<!-- <div class="section-body">
		<div class="row">
			<div class="col-12">
				<div class="card card-primary">
					<div class="card-header">
						<h4>Support Ticket</h4>
						<div class="card-header-action">
							<a data-toggle="collapse" class="btn btn-icon btn-info" href="#tableCollapse">
								<i class="fas fa-minus"></i></a>
						</div>
					</div>
					<div class="collapse support-ticket-panel show" id="tableCollapse" *ngIf="this.new_table==true">
						<div class="card-body">
							<div class="form-group row mb-4">
								<div class="col-sm-12 col-md-7">

									<button type="submit" style="margin-right: 10px !important" class="btn btn-primary"
										(click)="createticket()"><i class="fas fa-plus-circle"></i> Create
										Tickets</button>


								</div>
							</div>
							<div class="table-responsive">
								<table class="table table-bordered support-ticket-table table-striped" id="">
									<thead>
										<tr>
											<th>Ticket Number</th>
											<th>Status</th>
											<th>Date</th>
											<th>Subject</th>
											<th>Department</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										<tr class="new-ticket" *ngFor="let l of opentickets;let i = index">
											<td><a (click)="gotck(l.ticket_no)"><b>#{{l.ticket_no}}</b></a></td>
											<td>
												<a (click)="gotck(l.ticket_no)" data-toggle="tooltip"
													title="Open Ticket"
													class="btn btn-danger btn-radius btn-icon icon-left btn-sm">
													<i class="fas fa-ticket-alt"></i> {{l.status_desc}}
												</a>
											</td>
											<td>{{l.created_dt}}</td>
											<td>{{l.ticket_subject}}</td>
											<td>{{l.department_name}}</td>
											<td>
												<a (click)="gotck(l.ticket_no)" data-toggle="tooltip" title="View"
													class="btn btn-danger btn-sm">
													<i class="fas fa-eye"></i> View Ticket
												</a>
											</td>
										</tr>




				
									</tbody>

									<tr *ngIf="recordNotFound == true">
										<td colspan="12">No Record Found</td>
									</tr>

								</table>
							</div>


							<div class="card-footer text-right" *ngIf="recordNotFound == false">

								<nav class="d-inline-block">
									<ul class="pagination mb-0" *ngIf="paginationData.info == 'show'">

										<li class="page-item">
											<a [class]="paginationData.backtab=='show' ? 'page-link' :'page-link disabled'"
												href="javascript:void(0)"
												(click)="paginationData.backtab=='show' ? open_ticket({'search_text':'','offset':paginationData.start}) : false"><i
													class="fas fa-angle-left"></i></a>
										</li>
										<li class="page-item" *ngIf="paginationData.backtab =='show'">
											<a class="page-link" href="javascript:void(0)"
												(click)="open_ticket({'search_text':'','offset':paginationData.back})"><i
													class="fas fa-angle-double-left"></i></a>
										</li>


										<li [class]="pagination.load ==false ? 'page-item active' :'page-item'"
											*ngFor="let pagination of paginationData.data;let i=index">
											<a class="page-link" href="javascript:void(0)"
												(click)=" pagination.load ==true ? open_ticket({'search_text':'','offset':pagination.offset_count}) : false">{{pagination.btn_length}}
												<span class="sr-only"
													*ngIf="pagination.load ==false">(current)</span></a>
										</li>

										<li class="page-item" *ngIf="paginationData.nexttab =='show'">
											<a class="page-link" href="javascript:void(0)"
												(click)="open_ticket({'search_text':'','offset':paginationData.next})"><i
													class="fas fa-angle-double-right"></i></a>
										</li>

										<li class="page-item">
											<a [class]="paginationData.nexttab =='show' ? 'page-link' : 'page-link disabled'"
												href="javascript:void(0)"
												(click)="paginationData.nexttab =='show' ? open_ticket({'search_text':'','offset':paginationData.end}) : false"><i
													class="fas fa-angle-right"></i></a>
										</li>
									</ul>
								</nav>
							</div>









						</div>
					</div>










					<div class="collapse support-ticket-panel show" id="tableCollapse" *ngIf="this.table==true">
						<div class="card-body">
							<div class="form-group row mb-4">
								<div class="col-sm-12 col-md-7">

									<button type="submit" style="margin-right: 10px !important" class="btn btn-primary"
										(click)="createticket()"><i class="fas fa-plus-circle"></i> Create
										Tickets</button>




								</div>
							</div>
							<div class="table-responsive">
								<table class="table table-bordered support-ticket-table table-striped" id="">
									<thead>
										<tr>
											<th>Ticket Number</th>
											<th>Status</th>
											<th>Date</th>
											<th>Subject</th>

											<th>Department</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										<tr class="new-ticket" *ngFor="let l of new_ticket;let i = index">
											<td><a (click)="gotck(l.ticket_no)"><b>#{{l.ticket_no}}</b></a></td>
											<td>
												<a (click)="gotck(l.ticket_no)" data-toggle="tooltip"
													title="Open Ticket"
													class="btn btn-danger btn-radius btn-icon icon-left btn-sm">
													<i class="fas fa-ticket-alt"></i> {{l.status_desc}}

												</a>
											</td>
											<td>{{l.created_dt}}</td>
											<td>{{l.ticket_subject}}</td>
	
											<td>{{l.department_name}}</td>
											<td>
												<a (click)="gotck(l.ticket_no)" data-toggle="tooltip" title="View"
													class="btn btn-danger btn-sm">
													<i class="fas fa-eye"></i> View Ticket
												</a>
											</td>
										</tr>




									</tbody>

									<tr *ngIf="recordNotFound == true">
										<td colspan="12">No Record Found</td>
									</tr>

								</table>
							</div>


							<div class="card-footer text-right" *ngIf="recordNotFound == false">

								<nav class="d-inline-block">
									<ul class="pagination mb-0" *ngIf="paginationData.info == 'show'">

										<li class="page-item">
											<a [class]="paginationData.backtab=='show' ? 'page-link' :'page-link disabled'"
												href="javascript:void(0)"
												(click)="paginationData.backtab=='show' ? open_ticket({'search_text':'','offset':paginationData.start}) : false"><i
													class="fas fa-angle-left"></i></a>
										</li>
										<li class="page-item" *ngIf="paginationData.backtab =='show'">
											<a class="page-link" href="javascript:void(0)"
												(click)="open_ticket({'search_text':'','offset':paginationData.back})"><i
													class="fas fa-angle-double-left"></i></a>
										</li>


										<li [class]="pagination.load ==false ? 'page-item active' :'page-item'"
											*ngFor="let pagination of paginationData.data;let i=index">
											<a class="page-link" href="javascript:void(0)"
												(click)=" pagination.load ==true ? open_ticket({'search_text':'','offset':pagination.offset_count}) : false">{{pagination.btn_length}}
												<span class="sr-only"
													*ngIf="pagination.load ==false">(current)</span></a>
										</li>

										<li class="page-item" *ngIf="paginationData.nexttab =='show'">
											<a class="page-link" href="javascript:void(0)"
												(click)="open_ticket({'search_text':'','offset':paginationData.next})"><i
													class="fas fa-angle-double-right"></i></a>
										</li>

										<li class="page-item">
											<a [class]="paginationData.nexttab =='show' ? 'page-link' : 'page-link disabled'"
												href="javascript:void(0)"
												(click)="paginationData.nexttab =='show' ? open_ticket({'search_text':'','offset':paginationData.end}) : false"><i
													class="fas fa-angle-right"></i></a>
										</li>
									</ul>
								</nav>
							</div>









						</div>
					</div>









					<div class="collapse support-ticket-panel show" id="tableCollapse" *ngIf="this.close_table==true">
						<div class="card-body">
							<div class="form-group row mb-4">
								<div class="col-sm-12 col-md-7">

									<button type="submit" style="margin-right: 10px !important" class="btn btn-primary"
										(click)="createticket()"><i class="fas fa-plus-circle"></i> Create
										Tickets</button>




								</div>
							</div>
							<div class="table-responsive">
								<table class="table table-bordered support-ticket-table table-striped" id="">
									<thead>
										<tr>
											<th>Ticket Number</th>
											<th>Status</th>
											<th>Date</th>
											<th>Subject</th>

											<th>Department</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										<tr class="new-ticket" *ngFor="let l of closedtickets;let i = index">
											<td><a (click)="gotck(l.ticket_no)"><b>#{{l.ticket_no}}</b></a></td>
											<td>
												<a (click)="gotck(l.ticket_no)" data-toggle="tooltip"
													title="Open Ticket"
													class="btn btn-danger btn-radius btn-icon icon-left btn-sm">
													<i class="fas fa-ticket-alt"></i> {{l.status_desc}}
												</a>
											</td>
											<td>{{l.created_dt}}</td>
											<td>{{l.ticket_subject}}</td>
											<td>{{l.department_name}}</td>
											<td>
												<a (click)="gotck(l.ticket_no)" data-toggle="tooltip" title="View"
													class="btn btn-danger btn-sm">
													<i class="fas fa-eye"></i> View Ticket
												</a>
											</td>
										</tr>



									</tbody>

									<tr *ngIf="recordNotFound == true">
										<td colspan="12">No Record Found</td>
									</tr>

								</table>
							</div>


							<div class="card-footer text-right" *ngIf="recordNotFound == false">

								<nav class="d-inline-block">
									<ul class="pagination mb-0" *ngIf="paginationData.info == 'show'">

										<li class="page-item">
											<a [class]="paginationData.backtab=='show' ? 'page-link' :'page-link disabled'"
												href="javascript:void(0)"
												(click)="paginationData.backtab=='show' ? open_ticket({'search_text':'','offset':paginationData.start}) : false"><i
													class="fas fa-angle-left"></i></a>
										</li>
										<li class="page-item" *ngIf="paginationData.backtab =='show'">
											<a class="page-link" href="javascript:void(0)"
												(click)="open_ticket({'search_text':'','offset':paginationData.back})"><i
													class="fas fa-angle-double-left"></i></a>
										</li>


										<li [class]="pagination.load ==false ? 'page-item active' :'page-item'"
											*ngFor="let pagination of paginationData.data;let i=index">
											<a class="page-link" href="javascript:void(0)"
												(click)=" pagination.load ==true ? open_ticket({'search_text':'','offset':pagination.offset_count}) : false">{{pagination.btn_length}}
												<span class="sr-only"
													*ngIf="pagination.load ==false">(current)</span></a>
										</li>

										<li class="page-item" *ngIf="paginationData.nexttab =='show'">
											<a class="page-link" href="javascript:void(0)"
												(click)="open_ticket({'search_text':'','offset':paginationData.next})"><i
													class="fas fa-angle-double-right"></i></a>
										</li>

										<li class="page-item">
											<a [class]="paginationData.nexttab =='show' ? 'page-link' : 'page-link disabled'"
												href="javascript:void(0)"
												(click)="paginationData.nexttab =='show' ? open_ticket({'search_text':'','offset':paginationData.end}) : false"><i
													class="fas fa-angle-right"></i></a>
										</li>
									</ul>
								</nav>
							</div>









						</div>
					</div>







				</div>
			</div>
		</div>


	</div> -->
</section>











<!-- Create Ticket Modal -->
<div class="modal fade" id="addNewPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
	aria-hidden="true">

	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
		<div class="modal-content addcustomernewallcss">
			<div class="modal-header">
				<h1 class="modal-title" id="exampleModalLongTitle">Create Tickets
				</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>

			</div>
			<div class="modal-body mousepoint">
				<form class="deal-register-form" [formGroup]="createinformation">

					<div class="form-group">
						<label for="partner-name">From</label>
						<input type="text" class="form-control" id="partner-name" formControlName="fromticket" readonly>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('fromticket').valid && createinformation.get('fromticket').touched">
							Please enter Name
						</div>
					</div>

					<!-- <div class="form-group">
						<label for="partner-name">Department</label>
						<input type="text" class="form-control" id="partner-name" formControlName="department" readonly>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('department').valid && createinformation.get('department').touched">
							Please enter Department
						</div>
					</div> -->
					<div class="form-group">
						<label for="partner-country">Country </label>
						<select name="country" id="sales_r" class="form-control" formControlName="country">
							<option [ngValue]="null" selected>Select Country</option>
							<option *ngFor="let con of countryList" value="{{con.id}}">
								{{con.name}}
							</option>
						</select>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('country').valid && createinformation.get('country').touched">
							Please enter Country
						</div>
					</div>
					<div class="form-group">
						<label for="partner-priority">Priority </label>
						<select name="priority" id="prior_r" class="form-control" formControlName="priority">
							<option [ngValue]="null" selected>Select Priority</option>
							<option *ngFor="let prior of priorityList" value="{{prior.id}}">
								{{prior.priority}}
							</option>
						</select>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('priority').valid && createinformation.get('priority').touched">
							Please enter Priority
						</div>
					</div>
					<div class="form-group">
						<label for="partner-requestType">Support Request Type </label>

						<select name="requestType" id="requestType_r" class="form-control"
							formControlName="requestType">
							<option [ngValue]="null" selected>Select Support Request Type</option>
							<option *ngFor="let type of supportRequestTypeList" value="{{type.id}}">
								{{type.type}}
							</option>
						</select>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('requestType').valid && createinformation.get('requestType').touched">
							Please enter Support Request Type
						</div>
					</div>

					<div class="form-group">
						<label for="partner-name">Subject</label>
						<input type="text" class="form-control" id="partner-name" formControlName="subject">
						<div class="error-message message-small"
							*ngIf="!createinformation.get('subject').valid && createinformation.get('subject').touched">
							Please enter Subject
						</div>
					</div>


					<div class="form-group">
						<label>Message</label>

						<!-- <kendo-editor [value]="value" formControlName="messages" style="height: 250px;"></kendo-editor> -->

						<textarea class="form-control" id="richTextAreacreated" formControlName="messages"
							(keydown)="onMessageSend($event)" #chat_message></textarea>

					</div>






					<div class="form-group">
						<label>File Upload </label>
						<div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop
							(onFileDropped)="uploadFiless($event)">
							<input hidden type="file" #fileInput (change)="uploadFile($event)">
						</div>
						<div class="files-list" *ngFor="let file of files;let i= index">
							<p> {{ file }} </p>
							<button class="delete-file" (click)="deleteAttachment(i)">
								<a data-toggle="tooltip" title="View" class="btn btn-danger">
									<i class="far fa-trash-alt"></i>
								</a>
							</button>
						</div>
					</div>

				</form>

			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" id="addCustomerSave" (click)="finishFunction()">
					Submit
				</button>
				<button type="button" class="btn btn-dark" data-dismiss="modal">
					Cancel
				</button>

			</div>
		</div>
	</div>
</div>
<!-- Create Ticket Modal End -->













<!--------------------------------------
Ticket Table View
---------------------------------------->

<div id="table_view">
	<div class="card ticket-table-view">
		<div class="card-body p-0">
			<div id="loading" class="loading-hide"></div>
			<table class="table table-striped table-md" style="color: #000;">
				<tr>
					<td colspan="20" class="search-text-tbl" style="padding: 20px;">
						<div class="input-group search-input"><input type="text" class="form-control"
								placeholder="Search TicketID - Subject - Sender Email" #agent_search>
							<div class="input-group-append">
								<button class="btn btn-primary" style="background-color:#318ce7;"><i
										class="fas fa-search"></i></button>&nbsp;&nbsp;&nbsp;
								<button class="btn btn-primary" style="background-color:#318ce7;"><i
										class="fas fa-search"></i> Global Search</button>
								<button class="btn btn-success" style="margin-left:5px;"><i
										class="fas fa-backspace"></i> Back</button>
							</div>
						</div>
					</td>
				</tr>

				<tr class="ticket-table-header">
					<!-- <th></th>
					<th> </th>
					<th>Subject</th>
					<th style="padding-left: 20px;">State</th>
					<th>Department</th>
					<th style="padding-left: 20px;">Priority</th>
					<th>Status</th> -->

					<th></th>
					<th>Ticket Number</th>
					<th>Subject</th>
					<th>Status</th>
					<th>Department</th>
					<th>Customer</th>
					<th>Action</th>

				</tr>




				<tbody>
					<!-- <tr *ngFor="let ticket of queue_list; let i = index"
						[ngClass]="{'closed-ticket' : ticket.ticket_status =='Closed','unread-ticket':ticket.ticket_status != 'Closed'}" title="Ticket from : {{ticket.ticket_from}}"> -->
					<tr *ngFor="let l of opentickets;let i = index">
						<td><input type="checkbox" name="emailtickets" class="emailtickets" name="checkbox"></td>
						<td style="font-weight: 700;">
							#{{l.ticket_no}}
						</td>
						<td>
							<a href="javascript:;" class="pointer fl" style="font-weight: 700;"
								(click)="gotck(l.ticket_no)">
								<span>{{l.ticket_subject}}
								</span>
								<div style="font-size: 12px;color: gray;" clsass="ticket-id dark-grey-clr">
									{{l.created_dt}}
								</div>
							</a>
						</td>
						<td style="width: 10%;">
							<div class="status-tag-wrap status-wrapper">
								<!-- <span
									[class]="ticket.ticket_status == 'Active' ? 'tag-active tag' : ticket.ticket_status == 'In Active' ? 'tag-inactive tag' :  ticket.ticket_status == 'New' ? 'tag-new tag' :  ticket.ticket_status == 'Pending' ? 'tag-pending tag': ticket.ticket_status == 'Un Assigned' ? 'tag-UnAssigned tag': ticket.ticket_status == 'Assigned' ? 'tag-Assigned tag': ticket.ticket_status == 'Progress' ? 'tag-UnAssigned tag': ticket.ticket_status == 'Completed' ? 'tag-Completed tag':ticket.ticket_status == 'Archived' ? 'tag-archived tag':ticket.ticket_status == 'Closed' ? 'tag-closed tag':'tag-new tag'"> -->
								<span>
									{{l.status_desc}}
								</span>

							</div>
						</td>
						<td style="width: 15%;">
							<!-- <div class="form-group fl">
								<div class="dropdown select-option" style="display: flex;">
									<div class="select-option-label" data-toggle="dropdown"
										class="dropdown-toggle">
										<span class="dropdown-label-icon"> Support SG</span>
									</div>

									<div  style="width: auto;"
										class="dropdown-menu">
										<div class="pullDown">
										

											<a href="javascript:void(0)">
											
												Department NAMe</a>
											<div class="dropdown-divider"></div>

										</div>
									</div>
									<div 
										class="status-tag-wrap status-wrapper">
										<span style="margin-left: 27px;	font-size: 11px;"
											>
											ticket assigned to 
										</span>
									</div>
								</div>
							</div> -->
							{{l.department_name}}
						</td>
						<td style="width: 25%;">
							{{l.ticket_from}}
						</td>
						<!-- <td>
							<div class="form-group fl">
								<div class="dropdown select-option">
									<div class="select-option-label" data-toggle="dropdown"
										class="dropdown-toggle">
										<span class="dropdown-label-icon">
											<span></span>
											Priority
										</span>
									</div>
									<div class="dropdown-menu" id="ticket">
									
										<div class="pullDown" >
											<a>
												
												<div
													class="green-bg-status status-bg">
												</div>High
												<span >
													<i class="fas fa-check"></i>
												</span>
											</a>
									
										</div>

									</div>
								</div>
							</div>
						</td> -->

						<td>
							<!-- <div class="form-group fl">
								<div class="dropdown select-option">
									<div class="select-option-label" data-toggle="dropdown"
										class="dropdown-toggle">
										<span class="dropdown-label-icon">
										ticket status	</span>
									</div>

									<div class="dropdown-menu"
										
										id="ticket">
										<div class="pullDown" >
										
											<a href="javascript:void(0)"
												class="dropdown-item active">status Desc</a>

										</div>
									</div>
								</div>
							</div> -->
							<a (click)="gotck(l.ticket_no)" data-toggle="tooltip" title="View"
								class="btn btn-danger btn-sm">
								<i class="fas fa-eye"></i> View Ticket
							</a>
						</td>
					</tr>
				</tbody>
			</table>

		</div>

	</div>
</div>

<!--------------------------------------
Ticket Table View End
---------------------------------------->